import { MMButton, MMSwitchInput } from '@components'
import { COOKIE, COOKIE_NAME } from '@constants'
import cn from '@integrations/classnames'
import { useContext, useState } from '@integrations/react'
import { configuration } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'

import styles from './ManageCookies.module.scss'

function ManageCookies({ setCookie }) {
  const { modalHide } = useContext(GlobalContext)

  const [optionalCookies, setOptionalCookies] = useState(true)

  function onSaveButtonClick() {
    setCookie(
      COOKIE_NAME.CONSENT,
      JSON.stringify({
        necessaryCookies: true,
        optionalCookies
      }),
      {
        days: COOKIE.EXPIRATION_DAYS,
        maxAge: COOKIE.MAX_AGE_SECONDS,
        domain: configuration.isLocal() ? null : '.banky.io'
      }
    )
    modalHide()
  }

  return (
    <div className={cn(styles['manage-cookies-wrapper'], 'manage-cookies-wrapper')} data-test='manage-cookies-modal'>
      <h2 className={cn('title')}>{tr('FRONTEND.COOKIE_CONSENT.NEED_COOKIES_TITLE', 'Necessary Cookies')}</h2>

      <div className={cn(styles['switch-container'], 'switch-container')}>
        <div>
          <p>
            {tr(
              'FRONTEND.COOKIE_CONSENT.NEED_COOKIES',
              'We need to use these cookies to make our website work. These are all necessary for us to function and cannot be switched off in our systems. They are for setting responses to actions made by you, such as setting your privacy preferences, logging in or filling forms.'
            )}
          </p>
        </div>
        <MMSwitchInput disabled outline checked />
      </div>

      <h2>{tr('FRONTEND.COOKIE_CONSENT.ST_COOKIE_POLICY', 'Banky cookies policy')}</h2>

      <div className={cn(styles['switch-container'], 'switch-container')}>
        <div>
          <p>
            {tr(
              'FRONTEND.COOKIE_CONSENT.COUNT_VISITS',
              'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. All information that our cookies collect is aggregated and anonymous.'
            )}
          </p>
          <p>
            {tr(
              'FRONTEND.COOKIE_CONSENT.SEE_PAGES_AND_LINKS',
              "These also allow us to see the pages and links you have visited so we can prevent relevant ads. We don't store directly personal information but identify your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising."
            )}
          </p>
        </div>

        <MMSwitchInput outline checked={optionalCookies} onChange={(e) => setOptionalCookies(e.target.checked)} />
      </div>

      <div className={cn(styles['buttons-container'], 'buttons-container')}>
        <MMButton
          variant='primary'
          caption={tr('FRONTEND.COOKIE_CONSENT.SAVE', 'Save')}
          onClick={onSaveButtonClick}
          fullWidth
          data-test='button-save'
        />
      </div>
    </div>
  )
}

export default ManageCookies
